import { render, staticRenderFns } from "./GiftTicket.vue?vue&type=template&id=74022ddb"
import script from "./GiftTicket.vue?vue&type=script&lang=js"
export * from "./GiftTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports